import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=3d94a641&scoped=true&"
import script from "./InvoicesTable.vue?vue&type=script&lang=js&"
export * from "./InvoicesTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d94a641",
  null
  
)

export default component.exports